
export function getHeaderOptions() {
    let headerOptions = {
        "Content-Type": 'application/json'
    }
    return headerOptions;
}